import { useClient } from '../../ClientContext';
import { useQuery } from '@apollo/client';
import useV2Query from 'utils/useV2Query';
import { GET_CLIENT_CURRENCY, GET_CURRENCIES } from '../queries';

const useCurrency = () => {
  const client = useClient();
  const { loading, error, data } = useQuery(GET_CLIENT_CURRENCY, {
    variables: { clientId: client?.id },
  });

  const clientCurrencyIdDefault = data?.client?.currencyId;

  const {
    data: getCurrenciesData,
    error: getCurrenciesError,
    loading: getCurrenciesLoading,
  } = useV2Query(GET_CURRENCIES);

  const currencies = getCurrenciesData?.currencies || [];

  const isLoading = loading || getCurrenciesLoading;
  const hasError = !!error || !!getCurrenciesError;

  return {
    currencies,
    hasError,
    isLoading,
    clientCurrencyIdDefault,
  };
};

export default useCurrency;
